export const getPrice = (amount: number) => (
	new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(amount)
)
